import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { api, ApiError } from '@/lib/axios'
import { queryClient } from '@/lib/tanstack'

async function removeApplicationAccountUsers(
  applicationAccountUserId: string,
  newPassword?: string,
) {
  const url = `/application-account-users/${applicationAccountUserId}`
  const params = newPassword ? { newPassword } : undefined

  return api.backend.delete(url, { params })
}

export function useRemoveProfileAccess() {
  const { mutateAsync } = useMutation<
    unknown,
    AxiosError<ApiError>,
    { applicationAccountUserId: string; newPassword?: string }
  >({
    mutationKey: ['/application-account-users/delete'],
    mutationFn: ({ applicationAccountUserId, newPassword }) =>
      removeApplicationAccountUsers(applicationAccountUserId, newPassword),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['/user/current-accounts'],
        exact: false,
      })
      queryClient.invalidateQueries({ queryKey: ['/user/get-user-info'] })
      queryClient.invalidateQueries({
        queryKey: ['/users-access/paginate'],
        exact: false,
      })
    },
  })

  const handleRemoveProfileAccess = async (
    applicationAccountUserId: string,
    newPassword?: string,
  ) => {
    return mutateAsync({ applicationAccountUserId, newPassword })
  }

  return {
    handleRemoveProfileAccess,
  }
}
